(function () {
  // =========================
  // RamenPanda Easteregg
  // =========================

  const DISCOUNT_CODE = "Ram3nPanda";

  // --- Timing ---
  const SHOW_AFTER_NO_CART_MS = 10 * 60 * 1000; // 10min wenn Warenkorb leer
  const SHOW_AFTER_WITH_CART_MS = 30 * 1000;    // 30s wenn Warenkorb hat Items

  // Optional: nach "Später" wie lange nicht mehr zeigen
  const APPEAR_COOLDOWN_MS = 30 * 60 * 1000; // 30min

  // --- Look & feel ---
  const PANDA_SIZE = 140; // px (Container)
  const EDGE_PEEK = 55;   // px sichtbar (Rest außerhalb)
  const IMAGE_SCALE = 1.3;

  // Bild-URL kommt idealerweise vom Script-Tag (data-attr)
  const scriptEl =
    document.currentScript || document.querySelector("script[data-rp-panda]");
  const PANDA_IMAGE_URL = scriptEl?.dataset?.pandaUrl || "";

  if (!PANDA_IMAGE_URL) {
    console.warn(
      "[RamenPanda] pandaUrl fehlt. Bitte im Script-Tag data-panda-url setzen."
    );
    return;
  }

  // --- Storage Keys ---
  const K_FIRST_SEEN = "rp_first_seen_ts";
  const K_LAST_HIDE = "rp_last_hide_ts";
  const K_LAST_SHOWN_TS = "rp_last_shown_ts";
  const K_CART_UNBLOCK_TS = "rp_cart_unblock_ts";

  // Fixe Position/Rotation nur 1x wählen:
  const K_PLACEMENT_ID = "rp_panda_placement_id";     // sessionStorage
  const K_PLACEMENT_X = "rp_panda_placement_x";       // sessionStorage (für random top/bottom)
  const K_PLACEMENT_Y = "rp_panda_placement_y";       // sessionStorage (für random left/right)
  const K_PLACEMENT_ROT = "rp_panda_placement_rot";   // sessionStorage

  // --- Helpers ---
  const now = () => Date.now();
  const clamp = (v, min, max) => Math.min(Math.max(v, min), max);

  // --- State ---
  const nowTs = now();

  const firstSeen = Number(localStorage.getItem(K_FIRST_SEEN)) || nowTs;
  if (!localStorage.getItem(K_FIRST_SEEN)) {
    localStorage.setItem(K_FIRST_SEEN, String(firstSeen));
  }

  const lastHide = Number(localStorage.getItem(K_LAST_HIDE)) || 0;
  const inCooldown = nowTs - lastHide < APPEAR_COOLDOWN_MS;

  const lastShownTs = Number(sessionStorage.getItem(K_LAST_SHOWN_TS)) || 0;

  // =========================
  // DOM: Styles + Elements
  // =========================
  const style = document.createElement("style");
  style.textContent = `
    #rp-panda {
      position: fixed;
      width: ${PANDA_SIZE}px;
      height: ${PANDA_SIZE}px;
      z-index: 999999;
      cursor: pointer;
      display: none;
      user-select: none;
      -webkit-tap-highlight-color: transparent;
      transform-origin: center;
      will-change: transform, top, left, right, bottom;
    }
    #rp-panda .rp-wrap {
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;
    }
    #rp-panda img {
      width: 120px;
      height: auto;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0px; /* "peek" looks good with this; change if needed */
      pointer-events: none;
    }

    #rp-modal-backdrop {
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,.55);
      z-index: 999998;
      display: none;
    }
    #rp-modal {
      position: fixed;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: min(520px, calc(100vw - 32px));
      background: #fff;
      border-radius: 18px;
      padding: 18px 18px 16px;
      z-index: 999999;
      display: none;
      box-shadow: 0 18px 50px rgba(0,0,0,.25);
      font-family: inherit;
      overflow: hidden;
    }
    #rp-modal .rp-head {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 10px;
    }
    #rp-modal .rp-head img {
      width: 200px;
      height: 200px;
      object-fit: contain;
      border-radius: 14px;
      background: transparent;
      padding: 6px;
      flex: 0 0 auto;
    }
    #rp-modal h3 {
      margin: 0;
      font-size: 20px;
      line-height: 1.2;
    }
    #rp-modal p {
      margin: 0 0 12px 0;
      font-size: 14px;
      line-height: 1.45;
      opacity: .9;
    }
    #rp-code {
      display: flex;
      gap: 10px;
      align-items: center;
      background: #f6f6f6;
      border-radius: 12px;
      padding: 10px 12px;
      margin: 12px 0 14px;
      flex-wrap: wrap;
    }
    #rp-code code {
      font-size: 16px;
      font-weight: 700;
      letter-spacing: .5px;
    }
    .rp-btnrow {
      display: flex;
      gap: 10px;
      justify-content: flex-end;
      flex-wrap: wrap;
    }
    .rp-btn {
      border: 0;
      border-radius: 12px;
      padding: 10px 14px;
      cursor: pointer;
      font-weight: 700;
    }
    .rp-btn-primary { background: #111; color: #fff; }
    .rp-btn-secondary { background: #eee; color: #111; }

    #rp-close {
      position: absolute;
      right: 10px;
      top: 10px;
      width: 34px;
      height: 34px;
      border-radius: 12px;
      border: 0;
      background: #f1f1f1;
      cursor: pointer;
      font-weight: 900;
      z-index: 2;
    }
  `;
  document.head.appendChild(style);

  const panda = document.createElement("div");
  panda.id = "rp-panda";
  panda.setAttribute("role", "button");
  panda.setAttribute("tabindex", "0");
  panda.setAttribute("aria-label", "Easteregg Panda");
  panda.innerHTML = `
    <div class="rp-wrap">
      <img src="${PANDA_IMAGE_URL}" alt="Panda" loading="lazy">
    </div>
  `;

  const backdrop = document.createElement("div");
  backdrop.id = "rp-modal-backdrop";

  const modal = document.createElement("div");
  modal.id = "rp-modal";
  modal.setAttribute("role", "dialog");
  modal.setAttribute("aria-modal", "true");
  modal.setAttribute("aria-label", "Panda Easteregg");
  modal.innerHTML = `
    <button id="rp-close" aria-label="Schließen">×</button>

    <div class="rp-head">
      <div>
        <h3>Du hast den Panda gefunden</h3>
        <p style="margin-top:20px; margin-bottom:15px;">Mit diesem Code bekommst du <b>zwei paar Chopsticks gratis</b> zu deiner Bestellung.</p>
        <div id="rp-code">
            <span>Code:</span>
            <code>${DISCOUNT_CODE}</code>
            <button class="rp-btn rp-btn-secondary" id="rp-copy">Kopieren</button>
        </div>
      </div>
      <img src="${PANDA_IMAGE_URL}" alt="Panda">
    </div>

    <div class="rp-btnrow">
      <button class="rp-btn rp-btn-secondary" id="rp-later">Später</button>
      <button class="rp-btn rp-btn-primary" id="rp-apply">Code anwenden</button>
    </div>
  `;

  document.body.appendChild(panda);
  document.body.appendChild(backdrop);
  document.body.appendChild(modal);

  const btnClose = modal.querySelector("#rp-close");
  const btnCopy = modal.querySelector("#rp-copy");
  const btnLater = modal.querySelector("#rp-later");
  const btnApply = modal.querySelector("#rp-apply");

  // =========================
  // Placement (1x random) + Rotation
  // =========================
  function computePlacement() {
    // Wir wählen eine von 8 Positionen und legen Rotation passend fest.
    // Rotation: 0° = "normal"
    // Wir drehen so, dass er aus dem Rand "reinguckt".
    // Zusätzlich: Ecken leicht zur Mitte kippen.

    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    const margin = 8;
    const outside = -(PANDA_SIZE - EDGE_PEEK);

    // placementId 0..7
    const placementId = Math.floor(Math.random() * 8);

    // Standardwerte
    let top = null, bottom = null, left = null, right = null;
    let rot = 0;

    // Für "random entlang Kante"
    const randX = clamp(Math.random() * (vw - PANDA_SIZE), margin, vw - PANDA_SIZE - margin);
    const randY = clamp(Math.random() * (vh - PANDA_SIZE), margin, vh - PANDA_SIZE - margin);

    // Rotation-Feintuning (Grad)
    const TILT = 12; // leichte Schräglage zur Mitte
    // Idee:
    // - Oben: leicht "runter" orientiert -> 180° wirkt oft natürlicher
    // - Unten: 0°
    // - Links: 90°
    // - Rechts: -90°
    // Ecken: +/- TILT in Richtung Mitte

    if (placementId === 0) { // oben links
      top = outside; left = margin;
      rot = 180 + TILT; // leicht zur Mitte (nach rechts) kippen
    } else if (placementId === 1) { // oben rechts
      top = outside; right = margin;
      rot = 180 - TILT; // leicht zur Mitte (nach links) kippen
    } else if (placementId === 2) { // unten links
      bottom = outside; left = margin;
      rot = 0 - TILT; // leicht zur Mitte (nach rechts) kippen
    } else if (placementId === 3) { // unten rechts
      bottom = outside; right = margin;
      rot = 0 + TILT; // leicht zur Mitte (nach links) kippen
    } else if (placementId === 4) { // links mitte (random y)
      left = outside; top = randY;
      rot = 90; // aus linkem Rand
    } else if (placementId === 5) { // rechts mitte (random y)
      right = outside; top = randY;
      rot = -90; // aus rechtem Rand
    } else if (placementId === 6) { // oben random
      top = outside; left = randX;
      rot = 180; // aus oberem Rand
    } else { // unten random
      bottom = outside; left = randX;
      rot = 0; // aus unterem Rand
    }

    return { placementId, top, bottom, left, right, rot, randX, randY };
  }

  function applyPlacement(p) {
    panda.style.top = p.top === null ? "auto" : p.top + "px";
    panda.style.bottom = p.bottom === null ? "auto" : p.bottom + "px";
    panda.style.left = p.left === null ? "auto" : p.left + "px";
    panda.style.right = p.right === null ? "auto" : p.right + "px";
    panda.style.transform = `rotate(${p.rot}deg)`;
  }

  function getOrCreatePlacementOnce() {
    const existingId = sessionStorage.getItem(K_PLACEMENT_ID);
    if (existingId !== null) {
      // Restore
      const placementId = Number(existingId);
      const top = sessionStorage.getItem(K_PLACEMENT_Y) === null ? null : Number(sessionStorage.getItem(K_PLACEMENT_Y));
      const left = sessionStorage.getItem(K_PLACEMENT_X) === null ? null : Number(sessionStorage.getItem(K_PLACEMENT_X));
      const rot = Number(sessionStorage.getItem(K_PLACEMENT_ROT)) || 0;

      // Wir speichern top/left "hilfsweise" – aber wir brauchen eigentlich alle Kantenwerte.
      // Daher: Wir rekonstruieren deterministisch je placementId mit gespeicherten random Koordinaten.
      const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
      const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
      const margin = 8;
      const outside = -(PANDA_SIZE - EDGE_PEEK);

      const randX = clamp(left ?? Math.random() * (vw - PANDA_SIZE), margin, vw - PANDA_SIZE - margin);
      const randY = clamp(top ?? Math.random() * (vh - PANDA_SIZE), margin, vh - PANDA_SIZE - margin);

      // Rebuild positions
      let p = { placementId, top: null, bottom: null, left: null, right: null, rot, randX, randY };

      const TILT = 12;

      if (placementId === 0) { p.top = outside; p.left = margin; p.rot = 180 + TILT; }
      else if (placementId === 1) { p.top = outside; p.right = margin; p.rot = 180 - TILT; }
      else if (placementId === 2) { p.bottom = outside; p.left = margin; p.rot = 0 - TILT; }
      else if (placementId === 3) { p.bottom = outside; p.right = margin; p.rot = 0 + TILT; }
      else if (placementId === 4) { p.left = outside; p.top = randY; p.rot = 90; }
      else if (placementId === 5) { p.right = outside; p.top = randY; p.rot = -90; }
      else if (placementId === 6) { p.top = outside; p.left = randX; p.rot = 180; }
      else { p.bottom = outside; p.left = randX; p.rot = 0; }

      return p;
    }

    // Create new
    const p = computePlacement();

    sessionStorage.setItem(K_PLACEMENT_ID, String(p.placementId));
    // Speichern wir die random Achse, damit es wirklich gleich bleibt (für pick 4/5/6/7)
    sessionStorage.setItem(K_PLACEMENT_X, String(p.randX));
    sessionStorage.setItem(K_PLACEMENT_Y, String(p.randY));
    sessionStorage.setItem(K_PLACEMENT_ROT, String(p.rot));

    return p;
  }

  // =========================
  // Modal
  // =========================
  function openModal() {
    modal.style.display = "block";
    backdrop.style.display = "block";
  }
  function closeModal() {
    modal.style.display = "none";
    backdrop.style.display = "none";
  }

  // =========================
  // Panda show/hide
  // =========================
    function showPanda() {
    const placement = getOrCreatePlacementOnce();
    applyPlacement(placement);

    panda.style.display = "block";
    sessionStorage.setItem(K_LAST_SHOWN_TS, String(now()));
    }


  function hidePandaWithCooldown() {
    panda.style.display = "none";
    localStorage.setItem(K_LAST_HIDE, String(now()));
  }

  // =========================
  // Cart logic
  // =========================
  async function cartHasItems() {
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      if (!res.ok) return false;
      const cart = await res.json();
      return cart && typeof cart.item_count === "number" && cart.item_count > 0;
    } catch (e) {
      return false;
    }
  }

  async function updateCartUnlock() {
    const has = await cartHasItems();
    if (!has) return;

    if (!localStorage.getItem(K_CART_UNBLOCK_TS)) {
      localStorage.setItem(K_CART_UNBLOCK_TS, String(now()));
    }
  }

  function isEligibleToShow() {
    const cartUnlockTs = Number(localStorage.getItem(K_CART_UNBLOCK_TS)) || 0;

    if (cartUnlockTs > 0) {
      return now() - cartUnlockTs >= SHOW_AFTER_WITH_CART_MS;
    }
    return now() - firstSeen >= SHOW_AFTER_NO_CART_MS;
  }

  function maybeShow() {
    if (inCooldown) return;

    // Wenn Panda schon mal gezeigt wurde:
    // erst nach 30s auf der neuen Seite wieder anzeigen
    const sinceLastShow = now() - lastShownTs;
    if (lastShownTs > 0 && sinceLastShow < 30 * 1000) return;

    if (isEligibleToShow()) showPanda();
    }


  // =========================
  // Events
  // =========================
  panda.addEventListener("click", openModal);
  panda.addEventListener("keydown", (e) => {
    if (e.key === "Enter" || e.key === " ") openModal();
  });

  backdrop.addEventListener("click", closeModal);
  btnClose.addEventListener("click", closeModal);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeModal();
  });

  btnLater.addEventListener("click", () => {
    closeModal();
    hidePandaWithCooldown();
  });

  btnCopy.addEventListener("click", async () => {
    try {
      await navigator.clipboard.writeText(DISCOUNT_CODE);
      btnCopy.textContent = "Kopiert!";
      setTimeout(() => (btnCopy.textContent = "Kopieren"), 1200);
    } catch (e) {
      alert("Bitte manuell kopieren: " + DISCOUNT_CODE);
    }
  });

  btnApply.addEventListener("click", () => {
    const redirect = encodeURIComponent(
      window.location.pathname + window.location.search
    );
    window.location.href =
      "/discount/" + encodeURIComponent(DISCOUNT_CODE) + "?redirect=" + redirect;
  });

  // =========================
  // Boot
  // =========================
  updateCartUnlock().then(maybeShow);
  setInterval(maybeShow, 1000);
  setInterval(updateCartUnlock, 5000);
})();
